/* eslint-disable no-nested-ternary */
import styled, { StyledProps } from 'styled-components'

import { GridCol } from '@ucheba/ui/components/Grid/desktop'

import { Picture } from '@ucheba/ui/components/Picture'

interface IStickyProps {
  space?: string
}

export const InstitutionLogo = styled(Picture)`
  max-width: 120px;
  max-height: 96px;
  margin-left: auto;
`

export const RightColumn = styled<StyledProps<any>>(GridCol)`
  padding-left: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '368px'};
  padding-top: ${({ paddingTop }) => paddingTop || '204px'};
`

export const LeftColumn = styled(GridCol)`
  height: min-content;
`

export const StickyContainer = styled.div<StyledProps<IStickyProps>>`
  z-index: 2;
  position: sticky;
  top: 16px;
  padding-bottom: 16px;
  margin-top: ${({ space }) => space || '-196px'};
`

export const OfficialRepresentativeWrapper = styled.div<IStickyProps>`
  padding-bottom: 16px;
  position: sticky;
  right: 0;
  bottom: 0;
  left: 0;
  margin-bottom: ${({ space }) => space || '-312px'};
`
